/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Menudrophint2Inputs */

const en_menudrophint2 = /** @type {(inputs: Menudrophint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drag here or click: up to ${i?.count} photos (JPEG, PNG, WebP) or one PDF.`)
};

const de_menudrophint2 = /** @type {(inputs: Menudrophint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hierher ziehen oder klicken: bis zu ${i?.count} Fotos (JPEG, PNG, WebP) oder ein PDF.`)
};

/**
* | output |
* | --- |
* | "Drag here or click: up to {count} photos (JPEG, PNG, WebP) or one PDF." |
*
* @param {Menudrophint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudrophint2 = /** @type {((inputs: Menudrophint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudrophint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudrophint2(inputs)
	return de_menudrophint2(inputs)
});
export { menudrophint2 as "menuDropHint" }